import {
  AlertsFromProvider,
  BCRContentContainer,
  BCRSuspense,
  LoadingFromProvider,
  useLoading,
} from "best-common-react";
import React, { lazy, Suspense, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import Alerts from "./components/elements/Alerts";
import { useUser } from "./contexts/UserContext";

const AuthenticatedApp = lazy(() => import("./modules/AuthenticatedApp"));
const UnauthenticatedApp = lazy(() => import("./modules/UnauthenticatedApp"));

const App: React.FC = () => {
  const { loggedIn } = useUser();
  const { setType, setAnimated } = useLoading();

  useEffect(() => {
    setType("player");
    setAnimated(true);
  }, []);

  return (
    <Suspense fallback={<BCRSuspense />}>
      <BCRContentContainer>
        <Alerts />
        <AlertsFromProvider />
        <LoadingFromProvider />
        <BrowserRouter>{loggedIn ? <AuthenticatedApp /> : <UnauthenticatedApp />}</BrowserRouter>
      </BCRContentContainer>
    </Suspense>
  );
};

export default App;
